import { DesktopLauncher } from "frappe/public/js/frappe/ui/desktop/desktop.js";

// Desktop LaunchPad Dialog Manager
frappe.desktop_launcher = {
	dialog: null,
	is_shown: false,

	/**
	 * Toggle the desktop launcher dialog
	 * If shown, hide it. If hidden, show it.
	 */
	toggle() {
		if (this.is_shown && this.dialog) {
			this.hide();
		} else {
			this.show();
		}
	},

	/**
	 * Show the desktop launcher dialog
	 */
	show() {
		// Prevent multiple instances
		if (this.is_shown && this.dialog) {
			return;
		}

		this.dialog = this.create_dialog();
		this.initialize_launcher(this.dialog.$body);
		this.dialog.show();
		this.is_shown = true;
	},

	/**
	 * Hide the desktop launcher dialog
	 */
	hide() {
		if (this.dialog) {
			this.dialog.hide();
			this.dialog = null;
			this.is_shown = false;
		}
	},

	/**
	 * Create and configure the dialog
	 * @returns {frappe.ui.Dialog} The configured dialog instance
	 */
	create_dialog() {
		const dialog = new frappe.ui.Dialog({
			title: __("Desktop"),
			size: "extra-large",
			on_hide: () => {
				this.is_shown = false;
				this.dialog = null;
			},
		});

		// Hide header for cleaner look
		dialog.header.hide();

		// Style the dialog body
		dialog.$body.addClass("desktop-dialog-body");
		dialog.$body.css({
			height: "650px",
			overflow: "hidden",
			padding: "0",
		});

		return dialog;
	},

	/**
	 * Initialize the desktop launcher in the given wrapper
	 * @param {jQuery} wrapper
	 */
	initialize_launcher(wrapper) {
		if (window.DesktopPage) {
			new DesktopLauncher(wrapper);
		} else {
			// Load required doctype if not available
			frappe.model.with_doctype("Desktop Icon", () => {
				new DesktopLauncher(wrapper);
			});
		}
	},
};
